"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./FilterInput.scss");

require("./FilterInputDark.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FilterInput = function FilterInput(props) {
  var _useState = (0, _react.useState)(props.value),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0, _react.useState)(props.value.length <= 0),
      _useState4 = _slicedToArray(_useState3, 2),
      isEmpty = _useState4[0],
      setEmpty = _useState4[1];

  var inputRef = (0, _react.useRef)();
  var stringifiedData = JSON.stringify(props.data);
  (0, _react.useEffect)(function () {
    filterRef.current();
  }, [value, stringifiedData]);

  var setState = function setState(inputValue) {
    if (!props.disabled) {
      setValue(inputValue);
      setEmpty(inputValue.length <= 0);
    }
  };

  var filter = function filter() {
    if (props.customFilter) {
      props.onChange(value);
    } else {
      var data = Array.isArray(props.data) ? props.data : convertDicToArray(props.data);
      var filteredData = data.filter(arrayFilter);
      props.onChange(filteredData);
    }
  };

  var filterRef = (0, _react.useRef)(filter);
  filterRef.current = filter;

  var convertDicToArray = function convertDicToArray(dic) {
    return Object.keys(dic).map(function (key) {
      var element = dic[key];
      element[props.keyResult] = key;
      return element;
    });
  };

  var arrayFilter = function arrayFilter(data) {
    if (_typeof(data) === 'object') {
      if (Array.isArray(data)) {
        // array de arrays
        return data.filter(arrayFilter).some(function (x) {
          return x;
        });
      } //array of objects
      else if (props.filterBy) {
          return searchByKeyIn(data);
        }

      throw new Error("filterBy value wasn't assigned as prop");
    }

    return valueIn(data); //array of string or integers
  };

  var searchByKeyIn = function searchByKeyIn(data) {
    if (Array.isArray(props.filterBy)) {
      return props.filterBy.some(function (element) {
        return element in data ? valueIn(data[element]) : false;
      });
    }

    return props.filterBy in data ? valueIn(data[props.filterBy]) : false;
  };

  var valueIn = function valueIn(data) {
    var stringData = data.toString();
    return props.ignoreCase ? stringData.toLowerCase().includes(value.toLowerCase()) : stringData.includes(value);
  };

  var onKeyDown = function onKeyDown(e) {
    if (!['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key) || value.length >= props.maxLength && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) e.preventDefault();
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    tabIndex: 'glc-filter',
    className: "gcl-filter-input ".concat(props.className, " ").concat(!isEmpty ? 'filled' : '', " ").concat(props.disabled ? 'disabled' : '')
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon lupa"
  }), /*#__PURE__*/_react["default"].createElement("input", {
    ref: inputRef,
    type: props.numeric ? 'number' : 'text',
    onChange: function onChange(e) {
      return setState(e.target.value);
    },
    value: value,
    placeholder: props.placeholder,
    disabled: props.disabled,
    onKeyDown: props.numeric ? onKeyDown : undefined,
    autoComplete: "new-password",
    readOnly: props.readOnly,
    maxlength: props.maxLength
  }), /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon close-circle ".concat(isEmpty && !props.onClose ? 'hide' : ''),
    onClick: function onClick() {
      if (isEmpty) {
        props.onClose();
      }

      inputRef.current.focus();
      setState('');
    }
  }));
};

FilterInput.propTypes = {
  disabled: _propTypes["default"].bool,
  value: _propTypes["default"].string,
  //initialInput Value
  data: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
  filterBy: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  //nombre de la(s) propiedade(s) a buscar
  customFilter: _propTypes["default"].bool,
  //true &&  onchange = inputValue
  ignoreCase: _propTypes["default"].bool,
  keyResult: _propTypes["default"].string,
  //solo cuando es diccionario
  color: _propTypes["default"].oneOf(['primary', 'secondary', 'tertiary']),
  className: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  numeric: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  maxLength: _propTypes["default"].number
};
FilterInput.defaultProps = {
  disabled: false,
  value: '',
  data: [],
  customFilter: false,
  keyResult: 'key',
  filterBy: '',
  color: 'primary',
  className: '',
  placeholder: '',
  maxLength: 255
};
var _default = FilterInput;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/Input/FilterInput/FilterInput.js
// module id = 696
// module chunks = 0